import { FC, useEffect, useState } from "react";
import { DrawerComponent } from "src/components/DialogComponent";
import ListIcon from "src/components/ui-icons/reports/ListIcon";
import TGButton from "src/components/ui/TGButton";
import { FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import { TestRegistryFilters } from "src/pages/Reports/TestTemplateRegistry/TestRegistryFilters";
import { NotificationsListFieldsRecordType, testRegistry } from "src/api/config/notifications.config";
import { TestRegistryList } from "./TestRegistryList";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectItems } from "src/modules/spItems/selectors";
import { getItems } from "src/modules/spItems/actions";

interface IProps {
  zIndex: number;
}

const ButtonAddTestFromRegistry: FC<IProps> = ({ zIndex }) => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const openModalAddTest = () => {
    setOpenDrawer(prev => !prev);
  };
  const [testName, setTestName] = useState("");
  const [selectedCollection, setSelectedCollection] = useState<NotificationsListFieldsRecordType["TestRegistry"] | {}>({});
  const testsRegistryList = useAppSelector(state => selectItems(state, testRegistry));
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      getItems({
        listName: testRegistry
      })
    );
  }, []);

  return (
    <div>
      <div className="flex justify-center">
        <TGButton icon={<ListIcon />} onClick={openModalAddTest}>
          Добавить Тест из реестра тестов
        </TGButton>
      </div>

      <FlexRow className={twMerge("text-black", "flex items-center justify-between p-9 flex-nowrap font-medium")}>
        <DrawerComponent percentage="87" open={openDrawer} zIndex={zIndex} toggleDrawer={openModalAddTest}>
          <div className="p-10">
            <header className="mb-[32px]">
              <h2 className="text-[30px] font-bold">Реестр тестов</h2>
            </header>
            <TestRegistryFilters setTestName={setTestName} testName={testName} selectedCollection={selectedCollection} setSelectedCollection={setSelectedCollection} />
          </div>
          <TestRegistryList testName={testName} selectedCollection={selectedCollection} testsList={testsRegistryList} openModalAddTest={openModalAddTest} />
        </DrawerComponent>
      </FlexRow>
    </div>
  );
};
export default ButtonAddTestFromRegistry;
